<template>
  <a-form ref="formRef" :model="formState" :rules="rules" layout="vertical">
    <a-form-item label="Correo electrónico" required name="email">
      <a-input v-model:value="formState.email" placeholder="Escribir correo" />
    </a-form-item>

    <a-form-item label="Nombres" required name="name">
      <a-input v-model:value="formState.name" placeholder="Escribir nombres" />
    </a-form-item>

    <a-form-item label="Apellidos" name="surname">
      <a-input v-model:value="formState.surname" placeholder="Escribir apellido" />
    </a-form-item>

    <a-form-item label="Teléfono de contacto" name="phone">
      <a-row :gutter="8" type="flex">
        <a-col span="6">
          <selector-country :code="code_phone" @selected="code_phone = $event" />
        </a-col>
        <a-col span="18">
          <a-input v-model:value="formState.phone" placeholder="Número de teléfono" />
        </a-col>
      </a-row>
    </a-form-item>

    <a-form-item name="is_demo">
      <template #label>
        ¿Estas iniciando un proceso de demo?
        <a-tooltip
          title="Esta respuesta será validada por nuestro equipo comercial para habilitar tu demo y brindarte la mejor experiencia. "
        >
          <InfoCircleOutlined style="margin-left: 5px" />
        </a-tooltip>
      </template>

      <a-radio-group v-model:value="formState.is_demo">
        <a-radio :value="true">Si</a-radio>
        <a-radio :value="false">No</a-radio>
      </a-radio-group>
    </a-form-item>

    <a-row>
      <a-col :span="24">
        <a-form-item class="item__checkbox">
          <a-checkbox v-model:checked="checkedTerms">
            Acepto<a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.securitec.pe/politicas-privacidad/"
            >
              Términos y condiciones</a
            >
            de {{ ProductName }}
          </a-checkbox>
        </a-form-item>
      </a-col>
      <a-col :span="24">
        <a-form-item class="item__information">
          <a-checkbox v-model:checked="checkedProduct">
            Acepto recibir información del producto y de {{ CompanyName }}
          </a-checkbox>
        </a-form-item>
      </a-col>
    </a-row>
    <div class="continue__register">
      <a-row>
        <a-col :span="24">
          <a-button
            class="continue"
            type="primary"
            html-type="submit"
            :loading="loading"
            @click="handleSubmit"
            :disabled="isDisabled"
          >
            Continuar
          </a-button>
        </a-col>
      </a-row>
    </div>
    <div class="login">
      <a-row>
        <a-col :span="24">
          <router-link to="/home" @click="handleOpenSearchWorkspace">
            ¿Ya tienes una cuenta?
          </router-link>
        </a-col>
      </a-row>
    </div>
  </a-form>
</template>

<script>
import { defineComponent, reactive, ref, toRaw, computed, watch } from "vue";
import { useStore } from "vuex";
import SelectorCountry from "@/app/shared/components/selectors/SelectorCountry.vue";
import { WorkspaceEvent } from "@/app/workspace/domain/events";
import EventBus from "@/app/shared/utils/eventBus";
import { CompanyName, ProductName } from "@/app/shared/utils/constants";

export default defineComponent({
  components: {
    SelectorCountry,
  },
  setup() {
    const formRef = ref();
    const store = useStore();
    const temporalForm = store.getters["getTemporalForm"];
    const code_phone = ref(1);
    const checkedProduct = ref(false);
    let formState;
    if (temporalForm) {
      formState = reactive({
        name: temporalForm.name,
        surname: temporalForm.surname,
        email: temporalForm.email,
        phone: temporalForm.phone,
        is_demo: temporalForm.is_demo,
      });
      code_phone.value = temporalForm.code_phone;
    } else {
      formState = reactive({
        name: "",
        surname: "",
        email: "",
        phone: "",
        is_demo: false,
      });
    }
    const rules = {
      name: [
        {
          required: true,
          message: "Campo requerido",
          trigger: "change",
        },
      ],
      surname: [
        {
          required: true,
          message: "Campo requerido",
          trigger: "blur",
        },
      ],
      email: [
        {
          required: true,
          message: "Email inválido",
          type: "email",
          trigger: "blur",
        },
      ],
      phone: [
        {
          required: true,
          message: "Teléfono inválido",
          transform: (value) => parseInt(value),
          type: "number",
        },
      ],
    };

    const filterOption = (input, _countries) => {
      return _countries.name.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    };

    const countries = computed(() => store.getters["getAllCountries"]);

    const copyCountries = ref([]);

    watch(countries, (newValue) => {
      copyCountries.value = newValue;
    });

    return {
      rules,
      formState,
      formRef,
      store,
      filterOption,
      countries,
      copyCountries,
      code_phone,
      checkedProduct,
      CompanyName,
      ProductName,
    };
  },
  data() {
    return {
      loading: false,
      checkedTerms: false,
      showCountry: false,
    };
  },
  computed: {
    isDisabled() {
      return (
        this.formState.name == "" ||
        this.formState.surname == "" ||
        this.formState.email == "" ||
        this.formState.phone == ""
      );
    },
  },
  methods: {
    filterCountries(value) {
      value = value.toLowerCase();
      this.copyCountries = this.countries.filter((item) => {
        return item.name.toLowerCase().includes(value);
      });
    },
    handleChange(data) {
      this.showCountry = data;
    },
    handleSubmit() {
      this.formRef
        .validateFields()
        .then(() => {
          this.handleSubmitForm(toRaw(this.formState));
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    async handleSubmitForm(data) {
      if (this.checkedTerms === false) {
        this.$message.error("Tienes que aceptar los Terminos y Condiciones para poder continuar");
        return;
      }
      try {
        this.loading = true;
        await this.$store.dispatch("createTemporalUser", {
          ...data,
          code_phone: this.code_phone,
          subscription: this.checkedProduct,
          customer_plan_config_token: this.$route.query.token,
        });
      } catch {
        this.$message.error("El correo ya se encuentra registrado", 10);
      } finally {
        this.loading = false;
      }
    },
    handleReceiveInformation(event) {
      this.$emit("checkbox-subscribe", event.target.checked);
    },
    handleOpenSearchWorkspace() {
      setTimeout(() => {
        EventBus.$emit(WorkspaceEvent.OPEN_MODAL_WORKSPACE);
      }, 500);
    },
  },
});
</script>

<style lang="sass" scoped>
.ant-form
  position: relative

  &-item
    margin-bottom: 10px

.item
  &__checkbox
    margin-bottom: 0

.flag
  width: 20px
  margin-bottom: 2px
  margin-right: 4px

.separator
  margin-bottom: 10px

.login
  text-align: center

.continue
  width: 100%

.continue__register
  margin: 20px 0 30px
</style>
